import _objectSpread from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/node/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import cx from 'classnames';
import React from 'react';
/**
 * TooltipWrapper
 * - Provides an optional container that determines where the tooltip aligns to
 */

export var TooltipWrapper = function TooltipWrapper(_ref) {
  var children = _ref.children,
      className = _ref.className,
      inline = _ref.inline,
      wrapperRef = _ref.wrapperRef,
      rest = _objectWithoutProperties(_ref, ["children", "className", "inline", "wrapperRef"]);

  return React.createElement("div", _objectSpread({
    className: cx('tds-tooltip-wrapper', {
      'tds-tooltip-wrapper--inline': inline
    }, className),
    ref: wrapperRef
  }, rest), children);
};